import { getAuthenticated, patchAuthenticated } from './http';

const NOTICES_API_BASE = '/api/notices';

export const fetchNotices = (params = {}) =>
  getAuthenticated(NOTICES_API_BASE, { params });

export const fetchUnreadNoticeCount = () =>
  getAuthenticated(`${NOTICES_API_BASE}/unread-count`);

export const markNoticeRead = (id) =>
  patchAuthenticated(`${NOTICES_API_BASE}/${id}/read`, {});

export const markAllNoticesRead = () =>
  patchAuthenticated(`${NOTICES_API_BASE}/read-all`, {});

export const archiveNotice = (id) =>
  patchAuthenticated(`${NOTICES_API_BASE}/${id}/archive`, {});

export const unarchiveNotice = (id) =>
  patchAuthenticated(`${NOTICES_API_BASE}/${id}/unarchive`, {});
